/* istanbul ignore file */

// Queries
import bookingRequests from './BookingRequestsQuery.gql';

// Mutations
import updateBookingRequest from './UpdateBookingRequestMutation.gql';

export const Query = {
  bookingRequests,
};

export const Mutation = {
  updateBookingRequest,
};
